import React from "react";

import { ChipInteractive, IconChevron } from "@busbud/horizon";

import { useAppContext } from "@app/helpers/hooks";

interface Props {
  goBack: () => void;
  label?: string;
}

export const BackButton: React.FC<Props> = props => {
  const { translator } = useAppContext();

  return (
    <ChipInteractive
      onClick={() => props.goBack()}
      iconStart={<IconChevron variant="left" size="md" />}
      id="button-back-to-results"
      data-cy="button-back-to-results"
      appearance="primary"
      variant="subtle"
    >
      {props.label || translator.t("!results.classes-fares.back-to-results")}
    </ChipInteractive>
  );
};
